<template>
  <div class="service-container">
    <img class="goBack" @click="goBack" src="../../../../assets/images/activity/goBack.png" alt="">
    <div class="container">
      <div class="service-title">
        服务详情
      </div>
      <div class="service-content" v-html="serviceDetail.serverDetails"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapState('pt', ['serviceDetail'])
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped lang="scss">
  .service-container {
    width: 100%;
    height: calc(100vh - 40px);
    background: #fdfdfd;
    position: relative;
    .goBack {
      position: absolute;
      top: 30px;
      left: 50px;
      width: 40px;
      height: 40px;
      cursor: pointer;
    }
    .container {
      width: 1200px;
      margin: 0 auto;
      min-height: 100%;
      // background: #f4f4f4;
      .service-title {
        width: 100%;
        height: 50px;
        font-size: 20px;
        line-height: 50px;
        font-weight: bold;
        text-align: center;
      }
      .service-content {
        width: 100%;
      }
    }
  }
</style>